export default {
  install: function (app, options) {
	  const Loading = {
		load: (promise) => {
			Loading.startLoading();
			return promise.then(Loading.endLoading).catch(Loading.endLoading);
		},
		startLoading: null,
		endLoading: null,
	  }
	app.mixin({
		beforeCreate: function(){
			this.$loading = Loading;
		}
	})
  }
}
